define([
	"dojo/_base/declare",
	"csi/table/New"
], function(declare,New) {

	return declare(New, {
		_canNavigate: function() {
			return false;
		},
		
		_newPostProcessRefNode: function(/*DOMNode*/refNode) {
			// summary: refresh parent rows
			this.widget.refreshParentRows(refNode);
		}
	});
});